<script setup lang="ts">
import {Minus, Plus} from "@lucide/vue";
import {Button} from "@/core/components/ui/button";
import {DURATION_STEP, MAX_DURATION, MIN_DURATION} from "@/agenda/constants";

defineProps<{
    disabled?: boolean;
}>();

const duration = defineModel<number>({required: true});

const stepDuration = (step: number) => {
    duration.value = Math.min(MAX_DURATION, Math.max(MIN_DURATION, duration.value + step));
};
</script>

<template>
  <div class="flex items-center gap-1">
    <Button
      type="button"
      variant="outline"
      size="icon"
      class="size-7 rounded-full"
      :disabled="disabled || duration <= MIN_DURATION"
      aria-label="Réduire la durée"
      @click="stepDuration(-DURATION_STEP)"
    >
      <Minus class="size-4" />
    </Button>
    <span class="w-16 text-center text-sm tabular-nums">{{ duration }} min</span>
    <Button
      type="button"
      variant="outline"
      size="icon"
      class="size-7 rounded-full"
      :disabled="disabled || duration >= MAX_DURATION"
      aria-label="Augmenter la durée"
      @click="stepDuration(DURATION_STEP)"
    >
      <Plus class="size-4" />
    </Button>
  </div>
</template>
